// actions.js// actions.js
import {
  GET_SHIFTS,
  GET_SHIFTS_SUCCESS,
  GET_SHIFTS_FAIL,
  ADD_SHIFTS,
  ADD_SHIFTS_SUCCESS,
  ADD_SHIFTS_FAIL,
  UPDATE_SHIFTS,
  UPDATE_SHIFTS_SUCCESS,
  UPDATE_SHIFTS_FAIL,
  DELETE_SHIFTS,
  DELETE_SHIFTS_SUCCESS,
  DELETE_SHIFTS_FAIL,
  SET_SHIFT_FIELD_ERRORS,
} from './actionTypes'

// Get Shifts
export const getShifts = () => ({
  type: GET_SHIFTS,
})

export const getShiftsSuccess = (shifts) => ({
  type: GET_SHIFTS_SUCCESS,
  payload: shifts,
})

export const getShiftsFail = (error) => ({
  type: GET_SHIFTS_FAIL,
  payload: error,
})

// Add Shift
export const addShift = (shift) => ({
  type: ADD_SHIFTS,
  payload: shift,
})

export const addShiftSuccess = (shift) => ({
  type: ADD_SHIFTS_SUCCESS,
  payload: shift,
})

export const addShiftFail = (error) => ({
  type: ADD_SHIFTS_FAIL,
  payload: error,
})

// Update Shift
export const updateShift = (shift) => ({
  type: UPDATE_SHIFTS,
  payload: shift,
})

export const updateShiftSuccess = (shift) => ({
  type: UPDATE_SHIFTS_SUCCESS,
  payload: shift,
})

export const updateShiftFail = (error) => ({
  type: UPDATE_SHIFTS_FAIL,
  payload: error,
})

// Delete Shift
export const deleteShift = (id) => ({
  type: DELETE_SHIFTS,
  payload: id,
})

export const deleteShiftSuccess = (id) => ({
  type: DELETE_SHIFTS_SUCCESS,
  payload: id,
})

export const deleteShiftFail = (error) => ({
  type: DELETE_SHIFTS_FAIL,
  payload: error,
})

// Set Field Errors
export const setShiftFieldErrors = (errors) => ({
  type: SET_SHIFT_FIELD_ERRORS,
  payload: errors,
})





